<template>
  <div>
    <div id="address" v-if="isPC">
      <div class="main">
        <p class="adress-title">{{ $t('address.address') }}</p>
        <div class="bg-white address-tabs">
          <el-tabs v-model="addressType" @tab-click="handleTabClick">
            <el-tab-pane label="Shipping Address" name="shippingAddress"></el-tab-pane>
            <el-tab-pane label="Billing Address" name="billingAddress"></el-tab-pane>
          </el-tabs>
        </div>
        <div class="address bg-white">
          <div class="address-list" v-for="item in addressList" :key="item.id">
            <div class="address-card" :class="{ defaultAddress: item.isDefault === 1 }">
              <p class="address-info">
                <span style="word-wrap:break-word">{{ item.fullName }}</span>
                <br><span> {{ item.areaCode }}</span>
                <span> {{ item.phoneNumber }}</span>
              </p>
              <p class="address-info">{{ item.streetAddressLine1 }}</p>
              <p class="address-info">{{ item.streetAddressLine2 }}</p>
              <p class="address-info">{{ item.city }},{{ item.province}},{{getCountryName(item.countryCode)}}({{ item.countryCode }})</p>
              <p>
                <span class="address-info">{{ item.zipCode }}</span>
                <i v-show="item.vatCode" style="color:#8b93a3;">,</i>
                <span class="address-info">{{ item.vatCode }}</span>
                <i v-show="item.ioss" style="color:#8b93a3;">,</i>
                <span class="address-info">{{ item.ioss }}</span>
              </p>
              <span class="edit-address pointer" @click="editAddress(item)">{{$t('address.editTheAddress')}}</span>
              <div v-if="item.isDefault === 1" class="default-address-icon">
                <i class="el-icon-check"></i>
              </div>
            </div>
            <el-radio-group @change="value => setDefaultAddress(value, item.id)" v-model="item.isDefault">
              <el-radio v-if="item.isDefault === 0" :label="1">{{$t('address.setAsDefault')}}</el-radio>
              <el-radio v-if="item.isDefault === 1" :label="1">{{$t('address.defaultAddress')}}</el-radio>
            </el-radio-group>
            <span class="delete-area pointer" @click="deleteAddress(item.id)">{{$t('common.delete')}}</span>
          </div>
          <div class="add-address-card f-c-c" @click="addAddress">
            <div class="fd-c f--c">
              <i class="iconfont icon-a-add-line1" style="font-size:30px"></i>
              <p>{{ $t('address.addAddress') }}</p>
            </div>
          </div>
          <div class="clear"></div>
        </div>
      </div>

    </div>
    <div v-else class="mobile-address-box bg-white">
      <!-- <div class="mobile-add-address-card f-c-c" @click="$router.push('/personal-center/add-address')"> -->

      <div class="bg-white mobile-address-tabs">
        <el-tabs v-model="addressType" @tab-click="handleTabClick">
          <el-tab-pane label="Shipping Address" name="shippingAddress"></el-tab-pane>
          <el-tab-pane label="Billing Address" name="billingAddress"></el-tab-pane>
        </el-tabs>
      </div>
      <div class="mobile-add-address-card f-c-c" @click="addAddress">
        <div>
          <i class="iconfont icon-a-add-line1" style="font-size:0.26rem"></i>&nbsp;
          <span>{{ $t('address.addAddress') }}</span>
        </div>
      </div>
      <div class="mobile-address-list" v-for="item in addressList" :key="item.id">
        <div class="mobile-address-card" :class="{ defaultAddress: item.isDefault === 1 }">
          <p class="address-info">
            <span style="word-wrap:break-word">{{ item.fullName }}&nbsp;</span>
            <span> {{ item.areaCode }}</span>
            <span> {{ item.phoneNumber }}</span>
          </p>
          <p class="address-info">{{ item.streetAddressLine1 }}</p>
          <p class="address-info">{{ item.streetAddressLine2 }}</p>
          <p class="address-info">{{ item.city }},{{ item.province}},{{getCountryName(item.countryCode)}}({{ item.countryCode }})</p>
          <p>
            <span class="address-info">{{ item.zipCode }}</span>
            <i v-show="item.vatCode" style="color:#8b93a3;">,</i>
            <span class="address-info">{{ item.vatCode }}</span>
            <i v-show="item.ioss" style="color:#8b93a3;">,</i>
            <span class="address-info">{{ item.ioss }}</span>
          </p>
          <span class="mobile-edit-address pointer" @click="editAddress(item)">{{$t('address.editTheAddress')}}</span>
          <div v-if="item.isDefault === 1" class="default-address-icon">
            <i class="el-icon-check"></i>
          </div>
        </div>
        <div class="mobile-set-bar f-b-c">
          <el-radio-group @change="value => setDefaultAddress(value, item.id)" v-model="item.isDefault">
            <el-radio v-if="item.isDefault === 0" :label="1">{{$t('address.setAsDefault')}}</el-radio>
            <el-radio v-if="item.isDefault === 1" :label="1">{{$t('address.defaultAddress')}}</el-radio>
          </el-radio-group>
          <span class="delete-area pointer" @click="deleteMobileAddress(item.id)">{{$t('common.delete')}}</span>
        </div>
      </div>
    </div>
     <address-dialog ref="addressdialog" :addForm="addForm" @submitForm="submitForm"></address-dialog>
  </div>
</template>

<script>
import API from '@/api'
import Dialog from 'vant/lib/dialog'
import 'vant/lib/dialog/style'
import AddressDialog from '@/views/commodity/components/AddressDialog'
export default {
  components: { AddressDialog },
  data() {
    return {
      addressType: 'shippingAddress', // shippingAddress：发货地址，billingAddress：账单地址
      dialogVisible: false,
      addForm: {},
      title: '',
      show: false,
      rules: {
        name: [{ required: true, message: '请输入活动名称', trigger: 'blur' }]
      },
      addressData: [] // 地址列表
    }
  },
  created() {
    this.getAddressList()
    this.getAddressInfo()
  },
  computed: {
    addressList() {
      return this.$store.state.common.addressList
    }
  },
  methods: {

    handleTabClick(tab) {
      this.addressType = tab.name
      this.getAddressList()
    },
    deleteMobileAddress(id) {
      this.show = true
      Dialog.confirm({
        title: this.$t('address.deleteTip'),
        confirmButtonColor: '#99c41c',
        confirmButtonText: this.$t('common.confirm'),
        cancelButtonText: this.$t('common.cancel')
      })
        .then(() => {
          API.deleteAddress(id)
            .then(res => {
              this.$message.success(this.$t('promptText.msg40'))
              this.getAddressList()
            })
            .catch(result => {
              this.$message.error(result.data.message)
            })
        })
    },
    // 获取国家名
    getCountryName(countryCode) {
      let data = [...this.addressData]
      let arr = data.filter(item => item.code === countryCode)
      if (arr.length > 0) { return arr[0].name_en }
    },
    // 获取省市州数据
    getAddressInfo() {
      API.getAddressInfo({ dictTypeCode: 'data:address' })
        .then(res => {
          let data = JSON.parse(res.data)
          this.addressData = data
            .map(item => {
              return item.childrens
            })
            .flat(2)
        })
        .catch(result => {
          this.$message.error(result.data.message)
        })
    },

    // 地址列表
    getAddressList() {
      this.$store.dispatch('common/getAddressList', { type: this.addressType === 'shippingAddress' ? 0 : 1 })
    },

    addAddress() {
      this.$refs.addressdialog.show(undefined, true)
      console.log(this.addressType)
      this.addForm = { type: this.addressType === 'shippingAddress' ? 0 : 1 }
    },

    submitForm() {
      this.getAddressList()
    },

    // 设置默认地址
    setDefaultAddress(value, id) {
      this.addressList.forEach(item => {
        item.isDefault = item.id === id ? 1 : 0
      })
      API.setDefaultAddress(id)
        .then(() => {
          this.$message.success('Set the default address successfully')
          this.getAddressList()
        })
        .catch(result => {
          this.$message.error(result.data.message)
        })
    },

    // 编辑地址
    editAddress(item) {
      this.$refs.addressdialog.show()
      const editedItem = { ...item, type: this.addressType === 'shippingAddress' ? 0 : 1 } // 将 addressType 添加到 item
      this.addForm = editedItem
    },

    editMobileAddress(item) {
      this.$router.push({
        path: '/personal-center/add-address/',
        query: {
          address: JSON.stringify(item)
        }
      })
    },

    // 删除地址
    deleteAddress(id) {
      let that = this
      this.$confirm(that.$t('address.deleteTip'), that.$t('common.Warning'), {
        confirmButtonText: that.$t('common.confirm'),
        cancelButtonText: that.$t('common.cancel'),
        type: that.$t('common.warning')
      }).then(() => {
        API.deleteAddress(id)
          .then(res => {
            that.$message.success('Delete address successfully')
            that.getAddressList()
          })
          .catch(result => {
            that.$message.error(result.data.message)
          })
      })
    }
  }
}
</script>

<style lang="scss" scoped>

.address-tabs {
  /deep/ .el-tabs__header {
    margin-bottom: 0;
  }
  /deep/ .el-tabs__nav-scroll {
    padding-left: 40px;
  }
}
.adress-title {
  display: inline-block;
  font-size: 18px;
  line-height: 27px;
  font-weight: 600;
  padding-bottom: 10px;
  padding-left: 20px;
}
#address {
  font-family: Arial;
  margin: 18px 0 0 0;
}
.address {
  padding: 40px 0 40px 45px;
}
.page-title {
  display: inline-block;
  font-size: 18px;
  line-height: 27px;
  font-weight: 600;
  padding-bottom: 10px;
}
.address-list {
  float: left;
  margin: 0 40px 40px 0;
  width: 45%;
  max-width: 475px;
  min-width: 380px;
}
.address-card {
  position: relative;
  padding: 18px 22px;
  height: 248px;
  background: #ffffff;
  border: 0.5px solid #cdd4dd;
  box-sizing: border-box;
  border-radius: 6px;
  margin-bottom: 13px;
  overflow: auto;
}
.edit-address {
  position: absolute;
  right: 16px;
  bottom: 11px;
  color: #99c41c;
  font-size: 14px;
}
.clear {
  margin: 0px auto;
  clear: both;
  height: 0px;
  font-size: 0px;
  overflow: hidden;
}
.set-default {
  display: inline-block;
  color: #99c41c;
  font-size: 14px;
  margin-right: 30px;
}
.delete-area {
  color: #8b93a3;
  font-size: 14px;
  display: inline-block;
  margin-left: 30px;
}
.address-info {
  font-size: 14px;
  color: #8b93a3;
  line-height: 20px;
}
.defaultAddress {
  border: 0.5px solid #99c41c !important;
  background: rgba(187, 216, 103, 0.06) !important;
}
.default-address-icon {
  width: 29px;
  height: 29px;
  border-radius: 0 6px 0 29px;
  background: #99c41c;
  position: absolute;
  top: 0;
  right: 0;
  font-size: 20px;
  color: #fff;
  padding: 0 6px;
}
.add-address-card {
  width: 472.66px;
  height: 248px;
  border: 1px dashed #cdd4dd;
  box-sizing: border-box;
  border-radius: 6px;
  float: left;
  font-size: 14px;
  color: #10141d;
  line-height: 30px;
}
/deep/.el-input__inner {
  height: 36px;
}
/deep/.el-form-item__label {
  font-size: 14px;
  line-height: 20px;
  margin-bottom: 10px;
}
/deep/.el-form--label-top .el-form-item__label {
  float: none;
  display: inline-block;
  text-align: left;
  padding: 0 5px;
  font-family: Arial;
}
/deep/.el-form-item {
  margin-bottom: 10px;
}
// 移动端样式
.mobile-address-box {
  width: 100vw;
  padding: 0.16rem 0.32rem 0.56rem 0.32rem;
  min-height: calc(100vh - 0.86rem);
}
.mobile-address-tabs {
  /deep/ .el-tabs__header {
    margin-bottom: 0;
  }
  /deep/ .el-tabs__nav-scroll {
    padding-left: 40px;
  }
  margin-bottom: 30px;
}

.mobile-address-list {
  width: 100%;
}
.mobile-address-card {
  position: relative;
  padding: 0.36rem 0.44rem 0.24rem;
  background: #ffffff;
  border: 0.5px solid #cdd4dd;
  box-sizing: border-box;
  border-radius: 6px;
  margin: 0.26rem 0;
  overflow: auto;
}
.mobile-edit-address {
  display: inline-block;
  margin-top: 0.36rem;
  color: #99c41c;
  font-size: 0.28rem;
}
.mobile-set-bar {
  padding-bottom: 0.26rem;
}
.mobile-add-address-card{
  width: 100%;
  border: 1px dashed #CDD4DD;
  box-sizing: border-box;
  border-radius: 6px;
  font-size: 14px;
  color: #10141d;
  height: 1rem;
}

</style>
